module.exports = __webpack_public_path__ + "img/slika48.d4f6c1d5.jpg";